<template>
  <ion-page>
    <ion-header>
      <ion-toolbar>
        <ion-buttons slot="start">
          <ion-menu-toggle auto-hide="false">
            <img src="../assets/svg/logo-toolbar.svg">
          </ion-menu-toggle>
        </ion-buttons>
        <ion-buttons slot="end">
          <ion-button class="btn-back" @click="$router.go(-1)">Back</ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content padding>
      <bg :opaque="1"></bg>
      <ion-grid>
        <ion-row class="row-boxed">
          <ion-col size="12" class="text-right">
            <div class="align-top">
              <ion-button @click="addFolder" v-if="$store.state.user_role != 'client'">
                Create folder
              </ion-button>
              <ion-button v-if="$store.state.user_role != 'client'">
                <file-upload
                  input-id="uploadFile"
                  class="pointer"
                  :post-action="upload"
                  :data="{api_token: $store.state.api_token, folder: folder ? folder : baseFolder }"
                  :multiple="true"
                  :drop="true"
                  :drop-directory="false"
                  v-model="fileAdd"
                  @input-file="inputFile"
                  ref="uploadFile">
                    Add File
                </file-upload>
              </ion-button>
            </div>
          </ion-col>
          <ion-col size="12" class="text-left">
            <div class="breadcrumbs">
              <span class="pointer" @click="folder = ''">Home</span>
              <span class="pointer" v-for="(fs,i) in folderSplit" :key="'fs-'+i" @click="folder = baseFolder + fs.path"> &gt; {{ fs.name }}</span>
            </div>
          </ion-col>
          <ion-col size="12">
            <ion-list>
              <ion-item v-for="(d,i) in directories" :key="'d-'+i">
                <ion-avatar slot="end" v-if="$store.state.user_role != 'client'">
                  <ion-button @click="(ev) => deleteFile(ev,d,'folder')">Delete</ion-button>
                </ion-avatar>
                <ion-label @click="folder = d">
                  <img src="../assets/svg/folder.svg">
                  {{ getName(d) }}
                  </ion-label>
              </ion-item>

              <ion-item v-for="(f,i) in files" :key="'f-'+i">
                <ion-avatar slot="end" v-if="$store.state.user_role != 'client'">
                  <ion-button @click="(ev) => deleteFile(ev,f,'file')">Delete</ion-button>
                </ion-avatar>
                <ion-label>
                  <img src="../assets/svg/file.svg">
                  <a target="_blank" :href="fileUrl + '/' + f">{{ getName(f) }}</a>
                </ion-label>
              </ion-item>

              <ion-item v-if="!files.length && !directories.length">
                <ion-label>No files uploaded</ion-label>
              </ion-item>
            </ion-list>
          </ion-col>
        </ion-row>

      </ion-grid>
      <loader :visible="loader"></loader>
    </ion-content>
  </ion-page>
</template>

<script>
import axios from "axios"
import Vue from "vue"
import FileUpload from 'vue-upload-component'
export default {
  name: "Files",
  components: {
    FileUpload,
  },
  data: function() {
    return {
      baseFolder: '',
      upload: '',
      fileAdd: [],
      folder: '',
      files: [],
      directories: [],
      loader: false,
    }
  },
  watch: {
    folder: function () {
      this.getFiles()
    }
  },
  computed: {
    folderSplit: function () {
      if(this.folder.replace(this.baseFolder, '')) {
        let f = this.folder.replace(this.baseFolder, '').split('/')
        let d = []
        let i = 0
        let path = ''
        while (i < f.length) {
          let o = {
            path: path+f[i],
            name: f[i]
          }
          d.push(o)
          path += f[i] + '/'
          i++
        }
        return d
      }
      return []
    }
  },
  methods: {
    async inputFile(newFile, oldFile) {
      if (newFile && oldFile) {
        if (newFile.progress !== oldFile.progress) {
          this.loader = true;
        }
        if (newFile.error && !oldFile.error) {
          if (newFile.error && newFile.error == 'extension') {
            const toast = await this.$ionic.toastController.create({
              message: 'File not supported',
              color: 'danger',
              position: 'bottom',
              duration: 2000
            })
            await toast.present();
          }
        }
        if (newFile.success && !oldFile.success) {
          this.loader = false;
          // this.yacht.img = newFile.response.file
          this.getFiles()
          const toast = await this.$ionic.toastController.create({
            message: 'File added succesfully',
            color: 'success',
            position: 'bottom',
            duration: 2000
          })
          await toast.present();
        }
      }

      if (Boolean(newFile) !== Boolean(oldFile) || oldFile.error !== newFile.error) {
        if (!this.$refs.uploadFile.active) {
          this.$refs.uploadFile.active = true
        }
      }
    },
    getName(name) {
      if(name.includes('/')) {
        let n = name.split('/')
        name = n[n.length-1]
      }
      return name
    },
    getFiles() {
      this.loader = true;
      let folder = this.folder
      if(!folder && this.baseFolder) {
        folder = this.baseFolder + this.folder
      }
      console.log('FOLDER', folder)
      axios.post(this.apiUrl + '/api/v1/get-files', { api_token: this.$store.state.api_token, folder: folder })
      .then(async(response) => {
        let res = response.data

        Vue.set(this, 'files', res.data.files);
        Vue.set(this, 'directories', res.data.directories);

        this.loader = false;
      })
    },
    addFolder() {
      let folder = this.folder ? this.folder : this.baseFolder
      return this.$ionic.alertController
      .create({
        header: 'Name',
        inputs: [
          {
            name: 'name',
            id: 'name',
            placeholder: 'Folder name',
          },
        ],
        buttons: [
          {
            text: 'Cancel',
            role: 'cancel',
            cssClass: 'secondary',
            handler: () => {
            },
          },
          {
            text: 'Add',
            handler: (val) => {
              this.loader = true;
              axios.post(this.apiUrl + '/api/v1/add-folder', { api_token: this.$store.state.api_token, folder: folder, name: val.name })
              .then(() => {
                this.getFiles();
              })
            },
          },
        ]
      })
      .then(a => a.present())
    },
    deleteFile(ev,file,type) {
      ev.preventDefault()
      return this.$ionic.alertController
      .create({
        header: 'Are you sure?',
        buttons: [
          {
            text: 'Cancel',
            role: 'cancel',
            cssClass: 'secondary',
            handler: () => {
            },
          },
          {
            text: 'Delete',
            handler: () => {
              this.loader = true;
              axios.post(this.apiUrl + '/api/v1/delete-files', { api_token: this.$store.state.api_token, file: file, type: type })
              .then(() => {
                this.getFiles();
              })
            },
          },
        ]
      })
      .then(a => a.present())


    }
  },
  mounted: function() {
    if(this.$route.params.home) {
      this.baseFolder = this.$route.params.home+'/'
      this.loader = true;
      axios.post(this.apiUrl + '/api/v1/add-folder', { api_token: this.$store.state.api_token, folder: this.folder, name: this.$route.params.home })
      .then(() => {
        this.getFiles();
      })
    }
    if(this.$store.state.user_role == 'user') {
      this.$router.push('/home')
    }
    this.upload = this.apiUrl + '/api/v1/add-file';
    this.getFiles();
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
ion-avatar {
  min-width: 140px;
  text-align: right;
}
ion-item {
  cursor: pointer;
}

ion-label,
ion-label a {
  transition: .4s all;
  text-decoration: none;
  color: #000;
}

ion-label:hover,
ion-label:hover a {
  color: var(--ion-color-primary);
}

.breadcrumbs {
  padding: 0 16px;
}

ion-label img {
  height: 20px;
  position: relative;
  margin-right: 10px;
  top: 3px;
}
</style>